import en from './en';
import fr from './fr';
import { __currencyDisplay } from '../_utils';
import $ from 'jquery';

let resources = null;

export const getResources = () => {
    // set default lang
    if (resources == null) {
        let langResource = { ...en };

        if (typeof window.locale != 'undefined') {
            switch (window.locale.toLowerCase().substring(0, 2) == 'fr') {
                case 'fr':
                    langResource = { ...fr };
                    break;
            }
        }

        // This allow lang overwrites
        if (typeof window.resources != 'undefined') {
            langResource = {
                ...langResource,
                ...window.resources,
            };
        }

        resources = langResource;
    }

    return resources;
};
export const getTranslation = (key) => {
    const t = getResources();
    return typeof t[key] != 'undefined' ? t[key] : key;
};
export const getCurrency = (value) => {
    const currencyType =
        typeof window.currencyType != 'undefined'
            ? window.currencyType
            : 'dollar';

    switch (currencyType.toLowerCase()) {
        case 'dollar':
            return __currencyDisplay(value);
    }

    return value;
};


